// src/theme.ts
import { createTheme } from "@mui/material/styles";
import { COLORS } from "./constants";

export const theme = createTheme({
  unstable_sxConfig: {},
  palette: {
    mode: "light",
    primary: {
      main: COLORS.brand.primary,
    },
    secondary: {
      main: COLORS.brand.secondary,
    },
    background: {
      default: COLORS.background.bodyDefault,
      paper: COLORS.background.pagePrimary,
    },
    error: {
      main: COLORS.state.error,
      light: COLORS.state.errorLight,
    },
    text: {
      primary: COLORS.text.pagePrimary,
      secondary: COLORS.text.pageSecondary,
    },
    divider: COLORS.border.divider,
    success: {
      main: COLORS.state.success,
    },
  },
  shape: {
    borderRadius: 12,
  },
  typography: {
    button: {
      fontSize: "0.875rem",
      fontWeight: 500,
      letterSpacing: "0.1em",
      textTransform: "none",
    },
    body1: {
      fontSize: "1rem",
      fontWeight: 400,
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: "999px",
        },
        contained: {
          background: COLORS.button.primaryBackground,
          color: COLORS.button.primaryColor,
          "&:hover": {
            background: COLORS.button.primaryHoverBackground,
            color: COLORS.button.primaryHoverColor,
          },
        },
        text: {
          backgroundColor: "transparent",
          "&:hover": {
            backgroundColor: "transparent",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: {
          borderRadius: "24px",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 4,
        },
      },
    },
  },
});
